module.exports = __webpack_public_path__ + "assets/img/KeyReport_Thoby.ee89d6c9-ps.jpg";